export default "__VITE_ASSET__dfe10ecf__"